// plugins/the-weather-company/utilities/url-params.utils.ts

/**
 * Converts a parameters object to an ArcGIS URL template string
 * Filters out undefined, null, and empty string values
 */
export const paramsObjectToArcgisUrlTemplate = (
  paramsObject: Record<string, any>
): string => {
  return Object.entries(paramsObject)
    .filter(
      ([_, value]) => value !== undefined && value !== null && value !== ''
    )
    .map(([key, value]) => `${key}=${value}`)
    .join('&');
};

/**
 * Builds URL parameters for TWC API calls
 * @param params Base parameters
 * @param additionalParams Additional parameters to include
 * @returns A params object with only valid values
 */
export const buildTwcUrlParams = (
  params: Record<string, any>,
  additionalParams?: Record<string, any>
): Record<string, any> => {
  const result = { ...params };

  if (additionalParams) {
    Object.entries(additionalParams)
      .filter(
        ([_, value]) => value !== undefined && value !== null && value !== ''
      )
      .forEach(([key, value]) => {
        result[key] = value;
      });
  }

  return result;
};
